import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import StandardButton from "./standardButton";

const LogoutButton = () => {
  const { logout } = useAuth0();
  return (
    <StandardButton
      onClick={() =>
        logout({
          returnTo: window.location.origin,
        })
      }
    >
      Log Out
    </StandardButton>
  );
};

export default LogoutButton;
